import styled from "styled-components";

import { EXTRA_LARGE } from "@minerva-analytics/pantheon";
import { BACKGROUND_COLOR } from "../../theme";

export const PageContainer = styled.div`
  padding-top: 2rem;
  min-height: 75%;

  @media (max-width: ${EXTRA_LARGE}) {
    background-color: ${BACKGROUND_COLOR};
  }
`;
